/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './SupplierOnboard.scss';
import { withTranslation } from 'react-i18next';
import Multiselect from 'multiselect-react-dropdown';
import SupplierDetailsOnboardService from '../../../core/service/SupplierDetailsOnboardService';
import { useNavigate, useParams } from 'react-router-dom';
import UtilsService from '../../../core/service/UtilsService';
import LoginService from '../../../core/service/login-service';
import { toast } from "react-toastify";
import ErrorHandlingService from '../../../core/service/ErrorHandlingService';
import Header from '../Header/Header';
import Sidebar from '../../Common/Sidebar/Sidebar';
import { LS_TERMS_AGREED_KEY } from '../../../core/constants/common';

const SupplierOnboard  = ({ t }) => {
  const { supplierDetailsId } = useParams();
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [supplymaterial, setSupplyMaterials] = useState([]);
  const [supplymaterialchoosed, setSupplyMaterialChoosed] = useState([]);
  
  const [IBData, setIBData] = useState([]);
  const [IBchoosed, setIBChoosed] = useState([]);
  useEffect(() => {
    getSupplyMaterials();
    getCountry();
  }, []);

  const getSupplyMaterials = () => {
    SupplierDetailsOnboardService.getSupplymaterials(companyId)
      .then((response) => {
        setSupplyMaterials([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };


  const getCountry = () => {
    UtilsService.getCountryList()
      .then((response) => {
        setIBData([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };


  const onSelect = (selectedList, selectedItem) => {
    var array= arrayFormatter(selectedList);
    setSupplyMaterialChoosed([...array]);
  }

  const onRemove = (selectedList, removedItem) => {
    var array= arrayFormatter(selectedList);
    setSupplyMaterialChoosed([...array])
  
  }

  const onSelectIB = (selectedList, selectedItem) => {
    var array= arrayFormatter(selectedList);
    setIBChoosed([...array]);
  }

  const onRemoveIB = (selectedList, removedItem) => {
    var array= arrayFormatter(selectedList);
    setIBChoosed([...array])
  
  }


  const arrayFormatter = (selectedList) => {
    var array=[];
    for(let i=0;i<selectedList.length;i++) {
      var obj ={
        id:selectedList[i].id
      }
      array.push(obj)
    }
    return array;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    var body = {
      supplyMaterials: supplymaterialchoosed,
      interNationBranches: IBchoosed
    }
    SupplierDetailsOnboardService.onboardSupplierDetails(supplierDetailsId, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201 || response.status === 204) {
          toast.success('Success', {
            position: toast.POSITION.TOP_RIGHT,
          });
          checkLoginAuthority()
        }
      })
      .catch((error) => {
       
      });
  }

  const checkLoginAuthority = async (e) => {
    LoginService.checkAuthority()
      .then((response) => {
        var responseData = response.data.data;
        if (response.status === 200) {
          localStorage.setItem('authority', JSON.stringify(responseData));
          localStorage.setItem(LS_TERMS_AGREED_KEY, responseData?.profile?.user?.termsAgreed ?? true);
          navigate("/company_admin/home");
        }
      })
      .catch((error) => {
      
      });
  };

  return (
    <>
    <Header/>
 {/* <Sidebar/> */}
    <div className="page_wrapper_nosidebar">
    <section>

    <div className="Main_body">

      <div className="Company_formBox col-lg-12">
        <div className='List_header'>
          <h5 className='MH'>{t("SupplierCompany.label")}</h5>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="Profile_Pic_box">
              <div className="circle">
                <img className="profile-pic"
                  src="https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg" />
              </div>
            </div>
          </div>
          <div className="mb-4 row mx-0">
            <div className="col-lg-6 p-2">
              <label className="mb-1">{t("SupplyMaterial.label")}</label>
                <Multiselect
                  options={supplymaterial} // Options to display in the dropdown
                  // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                  onSelect={onSelect} // Function will trigger on select event
                  onRemove={onRemove} // Function will trigger on remove event
                  displayValue="name" // Property name to display in the dropdown options
                />
            </div>
            <div className="col-lg-6 p-2">
              <label className="mb-1">{t("InternationalBranches.label")}</label>
              <Multiselect
                  options={IBData}
                  onSelect={onSelectIB} 
                  onRemove={onRemoveIB} 
                  displayValue="name"
                />
            </div>
          </div>
          <div className="text-center">
            <button type="submit" className="btn btn-primary px-4 sbmBtn">{t("submit.label")}</button>
          </div>

        </form>
      </div>

    </div>
  </section>
  </div>
  </>
  )
};

export default withTranslation()(SupplierOnboard);
